import { compose, branch, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import {
  selectCustomerFirstName,
  selectCustomerEmail,
  selectCustomerPhotoUri,
  selectCustomerHasSponsor
} from '../../../../../store/selectors/customerProfile'
import {
  selectSponsorshipFullName,
  selectSponsorshipPhone,
  selectSponsorshipEmail,
  selectSponsorshipNmls,
  selectSponsorshipCorporationName,
  selectSponsorshipPhotoUri
} from '../../../../../store/selectors/sponsorship'
import {
  selectLoading,
  selectShowPrequalPrompt,
  selectPrequalRequested
} from '../../../../../store/selectors/affordability'
import { sendPrequalRequestForClient, toggleAffordabilityModal } from '../../../../../actions/affordability'
import LoadingBlock from '../../../../shared/Loading/LoadingBlock'

const AffordabilityPromptPrequalContainer = compose(
  connect(
    state => ({
      customerProfileEmail: selectCustomerEmail(state),
      customerProfileFirstName: selectCustomerFirstName(state),
      customerProfilePhotoUri: selectCustomerPhotoUri(state),
      isSponsored: selectCustomerHasSponsor(state),
      loading: selectLoading(state),
      requested: selectPrequalRequested(state),
      show: selectShowPrequalPrompt(state),
      sponsorPhotoUri: selectSponsorshipPhotoUri(state),
      sponsorProfileCorporationName: selectSponsorshipCorporationName(state),
      sponsorProfileEmail: selectSponsorshipEmail(state),
      sponsorProfileFullName: selectSponsorshipFullName(state),
      sponsorProfileNmls: selectSponsorshipNmls(state),
      sponsorProfilePhone: selectSponsorshipPhone(state)
    }),
    dispatch => ({
      onConfirm: () => dispatch(sendPrequalRequestForClient()),
      onReject: () => dispatch(toggleAffordabilityModal()),
      onClose: () => dispatch(toggleAffordabilityModal())
    })
  ),
  branch(
    ({ loading }) => loading,
    () => LoadingBlock
  ),
  branch(({ show }) => !show, renderNothing)
)

export default AffordabilityPromptPrequalContainer
